import React,{useEffect, useState} from 'react'
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './Profile.css'
import { environment } from '../../environment';

const Profile = () => {
    let token = localStorage.getItem("token") ? localStorage.getItem("token") : null;
    let data = token ?  JSON.parse(atob(token.split('.')[1])) : {};
    let user = data.data;

    const [userTermins, setuserTermins] = useState([]);
    const [tid, setTid] = useState('');

    const fetchUserTermins = `${environment.LOCALHOST_URL}/auth/user/termins/${user._id}`;

    useEffect( () => {
         axios(fetchUserTermins, {
            method: "get"
        }).then((termins) => {
            setuserTermins(termins.data);
            console.log({user_termins:termins.data})
        }).catch((error) => console.log(error))
    }, [])

    return (
        <>
<section className="section about-section gray-bg" id="about">
            <div className="container">
                <div className="row align-items-center flex-row-reverse">
                    <div className="col-lg-6">
                        <div className="about-text go-to">
                            <h3 className="dark-color">Mirësevini {user.username} </h3>
                            <h6 className="theme-color lead">Llogaria juaj ne Golden Touch</h6>
                            <div className="row about-list">
                                <div className="col-md-6">
                                    <div className="media">
                                        <label>E-mail</label>
                                        <p> {user.email} </p>
                                    </div>
                                    <div className="media">
                                        <label>Phone</label>
                                        <p> {user.phone ? user.phone : "Not available"} </p>
                                    </div>

                                    <div className="media">
                                        <label>Total termine</label>
                                        <p> {userTermins.length} </p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="counter">
                    <h3 style={{textAlign: 'center', color: 'gray'}}> Terminet tuaja </h3> <br />
                    <table className="table">
                    <thead>
                        <tr>
                        <th scope="col">#</th>
                        <th scope="col">Termin ID</th>
                        <th scope="col">Data</th>
                        <th scope="col">Ora</th>
                        <th scope="col">Konfirmuar</th>
                        <th scope="col">Paguar</th>
                        <th scope="col">Cmimi</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            
                            userTermins.map((termin, i) => (
                                <tr>
                                <th scope="row"> {i+1} </th>
                                <td> { termin._id.slice(10,15).toUpperCase() }</td>
                                <td> { termin.terminDate } </td>
                                <td> { termin.terminHour } </td>
                                <td> { termin.confirmed === false ? <p className='badge bg-danger'> Jo </p> : <p className='badge bg-success'> Po </p> } </td>
                                <td> { termin.isPaid === false ? <p className='badge bg-danger'> Jo </p> : <p className='badge bg-success'> Po </p>  } </td>
                                <td> { termin.price > 0 ? termin.price + " den" : "Në pritje" } </td>
                                </tr>
                       
                            ))
                        }
                    </tbody>
                    </table>
                </div>
            </div>
        </section>
    </>
    )
}

export default Profile;
